import type { SimpleChanges } from '@angular/core';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  output,
} from '@angular/core';

import {
  ButtonComponent,
  ButtonDropdownIndicatorDirective,
  ConnectedOverlayDirective,
  DropdownComponent,
  DropdownItemComponent,
  OverlayOriginDirective,
  RtStatefulComponent,
} from '@recruitee/user-interface';

import { DynamicHelpers } from '../../../helpers';
import type { DynamicText, SelectOptionsT, SelectOptionT } from '../../../types';

type State = {
  dropdownOpen: boolean;
  activeOptions: SelectOptionsT;
};

@Component({
  selector: 'rti-dynamic-form-additional-groups-dropdown',
  templateUrl: './dynamic-form-additional-groups-dropdown.component.html',
  styleUrls: ['./dynamic-form-additional-groups-dropdown.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonComponent,
    ButtonDropdownIndicatorDirective,
    ConnectedOverlayDirective,
    DropdownComponent,
    DropdownItemComponent,
    OverlayOriginDirective,
  ],
})
export class DynamicFormAdditionalGroupsComponent extends RtStatefulComponent<State> {
  @Input() public label: DynamicText;
  @Input() public options: SelectOptionsT;
  @Input() public selected: string[];

  public select = output<string>();

  constructor(
    private helpers: DynamicHelpers,
    cdRef: ChangeDetectorRef,
  ) {
    super(cdRef);
    this.createState({ dropdownOpen: false, activeOptions: [] });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if ('options' in changes || 'selected' in changes) {
      this.setState({
        ...this.state,
        activeOptions: this.options.filter(o => !this.selected.includes(o.value)),
      });
    }
  }

  public buildText(text: DynamicText): string {
    return this.helpers.buildText(text);
  }

  public get disabled(): boolean {
    return this.state.activeOptions.length === 0;
  }

  public toggleDropdown(): void {
    this.setState({ ...this.state, dropdownOpen: !this.state.dropdownOpen });
  }

  public selectOption(option: SelectOptionT): void {
    this.setState({ ...this.state, dropdownOpen: false });
    this.select.emit(option.value);
  }

  public trackByOption(_index: number, option: SelectOptionT): string {
    return option.value;
  }
}
